import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import '../../molecules/accordion-item/index.js';
import css_248z from './image-accordion.scss.js';

class ImageAccordion extends s {
    render() {
        return $ `<div class="image-accordion-wrapper"><slot name="image-accordion-item"></slot></div>`;
    }
}
ImageAccordion.styles = css_248z;
customElements.define('image-accordion', ImageAccordion);

export { ImageAccordion };
